<script setup lang="ts">
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'
type BadgeVariant = 'default' | 'success' | 'error' | 'warning' | 'muted'
type BadgeSize = 'sm' | 'md'

const props = defineProps<{
  variant?: BadgeVariant
  size?: BadgeSize
}>()

const badgeVariants = cva('inline-flex items-center rounded-full font-medium', {
  variants: {
    variant: {
      default:
        'bg-[color:var(--color-surface-muted)] text-[color:var(--color-ink)] border border-[color:var(--color-border-soft)]',
      success: 'bg-success/10 text-success',
      error: 'bg-error/10 text-error',
      warning: 'bg-warning/10 text-warning',
      muted:
        'bg-[color:var(--color-surface-muted)] text-[color:var(--color-ink-soft)] border border-[color:var(--color-border-soft)]',
    },
    size: {
      sm: 'px-2 py-0.5 text-xs',
      md: 'px-2.5 py-0.5 text-xs',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'md',
  },
})
</script>

<template>
  <span :class="cn(badgeVariants({ variant: props.variant, size: props.size }))">
    <slot />
  </span>
</template>
